import { BsTwitter, BsYoutube } from 'react-icons/bs';
import { FaFacebookF, FaLinkedinIn } from 'react-icons/fa';
import HeroImg1 from './assets/hero/Hero_img1.jpg';
import HeroImg2 from './assets/hero/Hero_img2.jpg';
import HeroImg3 from './assets/hero/Hero_img3.jpg';
import TeamImg2 from './assets/team/team2.jpg';
import TeamImg3 from './assets/team/team3.jpg';
import TeamImg4 from './assets/team/team4.jpg';
import TeamImg5 from './assets/team/team5.jpg';
import TeamImg6 from './assets/team/team6.jpg';
import TeamImg1 from './assets/team/team1.jpg';
import { v4 } from 'uuid';
import { useAppSelector } from './app/store';

export const navLinks = [
  {
    url: '/',
    title: 'Home',
  },
  {
    url: '/archives',
    title: 'Articles',
  },
  {
    url: '/dashboard',
    title: 'Dashboard',
  },

  {
    url: '/adrift',
    title: 'About us',
  },
  {
    url: '/submissions',
    title: 'Submit Paper',
  },
];

export const quickLinks = [
  {
    url: '/our_team',
    title: 'Our Team',
  },
  {
    url: '/archives',
    title: 'Journal Articles',
  },
  {
    url: '/',
    title: 'About us',
  },
];

export const socialLinks = [
  {
    url: 'https://fb.com',
    Icon: FaFacebookF,
  },
  {
    url: 'https://x.com',
    Icon: BsTwitter,
  },
  {
    url: 'https://youtube.com',
    Icon: BsYoutube,
  },
  {
    url: 'https://linkedin.com',
    Icon: FaLinkedinIn,
  },
];

export const regex = {
  alpha: /^[A-Za-z\s]+$/,
  specialAlpha: /^[A-Za-z.\s\-']+$/,
  specialAlpha2: /^[A-Za-z.,\s\-']+$/,
  alphaNumberic: /^[a-zA-Z0-9]+$/,
  email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  url: /^(http|https|ftp):\/\/([^\s/$.?#].[^\s]*)?$/,
  strongPword: /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/,
  notStrongPword: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/,
};

// TODO Delete these later

export const teamInfo = [
  {
    name: 'Prof. Alphonsus Radiano',
    imgUrl: TeamImg1,
    dept: 'Physics',
    school: 'University of Earth, Earth',
    email: 'email.mail.com',
    task: 'editor',
    id: 'id123',
    title: 'Professor',
  },
  {
    name: 'Dr. Lettus Craig',
    imgUrl: TeamImg2,
    dept: 'Bio-chemistry and Spirits',
    school: 'University of Illi, Mercha',
    email: 'email.mail.com',
    task: 'editor',
    id: 'id123d',
    title: 'Assistant Professor',
  },
  {
    name: 'Dr. Rattus Ratui',
    imgUrl: TeamImg3,
    dept: 'Brown Watery',
    school: 'University of Gass, Earth',
    email: 'email.mail.com',
    task: 'editor',
    id: 'id123g',
    title: 'Assistant Professor',
  },
  {
    name: 'Dr. LEfty Right',
    imgUrl: TeamImg4,
    dept: 'Physics',
    school: 'University of Earth, Earth',
    email: 'email.mail.com',
    task: 'reviewer',
    id: 'id123h',
    title: 'Assistant Professor',
  },
  {
    name: 'Dr. Risk Bright',
    imgUrl: TeamImg5,
    dept: 'Physical Anomalies',
    school: 'University of Brend, Malir',
    email: 'email.mail.com',
    task: 'reviewer',
    id: 'id12j3',
    title: 'Assistant Professor',
  },
  {
    name: 'Dr. Sombre Great',
    imgUrl: TeamImg6,
    dept: 'Art',
    school: 'University of Earth, Earth',
    email: 'email.mail.com',
    task: 'reviewer',
    id: 'id1r23',
    title: 'Assistant Professor',
  },
  {
    name: 'Prof. Alphonsus Radiano',
    imgUrl: TeamImg1,
    dept: 'Physics',
    school: 'University of Earth, Earth',
    email: 'email.mail.com',
    task: 'editor',
    id: 'id12y3',
    title: 'Professor',
  },
  {
    name: 'Prof. Lettus Craig',
    imgUrl: TeamImg2,
    dept: 'Bio-chemistry and Spirits',
    school: 'University of Illi, Mercha',
    email: 'email.mail.com',
    task: 'editor',
    id: 'iid123',
    title: 'Professor',
  },
  {
    name: 'Dr. Rattus Ratui',
    imgUrl: TeamImg3,
    dept: 'Brown Watery',
    school: 'University of Gass, Earth',
    email: 'email.mail.com',
    task: 'reviewer',
    id: 'id12f3',
    title: 'Assistant Professor',
  },
  {
    name: 'Dr. LEfty Right',
    imgUrl: TeamImg4,
    dept: 'Physics',
    school: 'University of Earth, Earth',
    email: 'email.mail.com',
    task: 'reviewer',
    id: 'id12e3',
    title: 'Assistant Professor',
  },
  {
    name: 'Dr. Risk Bright',
    imgUrl: TeamImg5,
    dept: 'Physical Anomalies',
    school: 'University of Brend, Malir',
    email: 'email.mail.com',
    task: 'reviewer',
    id: 'id12r3',
    title: 'Assistant Professor',
  },
  {
    name: 'Dr. Sombre Great',
    imgUrl: TeamImg6,
    dept: 'Art',
    school: 'University of Earth, Earth',
    email: 'email.mail.com',
    task: 'reviewer',
    id: 'id1jh23',
    title: 'Assistant Professor',
  },
];

export const heroInfo = [
  {
    imgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet.',
    desc: 'Lorem is not loerming well to isit emet dolor. Can see the emet otf the random shit just to test all hat it to it the off.',
    id: '1234',
  },
  {
    imgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolo Yeah and this is 2.',
    desc: 'Lorem is not loerming well to isit emet dolor. Can see the emet otf the random shit just to test all hat it to it the off.',
    id: '4567',
  },
  {
    imgUrl: HeroImg3,
    title: 'Lorem Ipsum And this is 3 js',
    desc: 'Lorem is not loerming well to isit emet dolor. Can see the emet otf the random shit just to test all hat it to it the off.',
    id: '67894',
  },
];

export const topArticles = [
  {
    imgUrl: HeroImg1,
    title:
      'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet. Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Olubo Joshua',
    category: 'Physics',
  },
  {
    imgUrl: HeroImg2,
    title:
      'Lorem Ipsum Dolo Yeah and this is Dolor Sit Emet:Lorem Ipsum Dolo Yeah and this is Dolor Sit Emet',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Olu Great',
    category: 'Social Sciences',
  },
  {
    imgUrl: HeroImg3,
    title:
      'Lorem Ipsum And this Dolor Sit Emet. Lorem Ipsum Dolo Yeah and this is Dolor Sit Emet',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Test Test',
    category: 'Chemistry',
  },
  {
    imgUrl: HeroImg1,
    title:
      'Lorem Ipsum Dolor SDolor Lorem Ipsum Dolo Yeah and this is Dolor Sit Emet: Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Last man',
    category: 'Arts',
  },
  {
    imgUrl: HeroImg1,
    title:
      'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet. Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Olubo Joshua',
    category: 'Physics',
  },
  {
    imgUrl: HeroImg2,
    title:
      'Lorem Ipsum Dolo Yeah and this is Dolor Sit Emet:Lorem Ipsum Dolo Yeah and this is Dolor Sit Emet',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Olu Great',
    category: 'Social Sciences',
  },
  {
    imgUrl: HeroImg3,
    title:
      'Lorem Ipsum And this Dolor Sit Emet. Lorem Ipsum Dolo Yeah and this is Dolor Sit Emet',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Test Test',
    category: 'Chemistry',
  },
  {
    imgUrl: HeroImg1,
    title:
      'Lorem Ipsum Dolor SDolor Lorem Ipsum Dolo Yeah and this is Dolor Sit Emet: Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Last man',
    category: 'Arts',
  },
];

export const allArticles = [
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Olubo Joshua',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolo Yeah and this is Dolor Sit Emet..',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Olu Great',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum And this Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Test Test',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor SDolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Last man',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
  {
    coverImgUrl: HeroImg1,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bill Clinton',
  },
  {
    coverImgUrl: HeroImg2,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Larry Graham',
  },
  {
    coverImgUrl: HeroImg3,
    title: 'Lorem Ipsum Dolor Sit Emet. Dolor Sit Emet.',
    desc: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate',
    id: v4(),
    author: 'Bax Dexter',
  },
];
